import { observable } from 'mobx'
import { ControllerStoreBase } from 'src/controllers/ControllerStoreBase'
import { persist } from 'mobx-persist'

export default class ExtensionController extends ControllerStoreBase {
  @persist('object') @observable data = {
    invoices: []
  };

  setInvoices (invoices) {
    this.data.invoices = invoices
  }

  getInvoices () {
    return this.data.invoices
  }

  static getInstance () {
    return super.construct(new ExtensionController(), true)
  }
}
